export default "/images/77b54b1441540bf6cee0fc8feed7a345.png";